import { render, staticRenderFns } from "./CardSingleCompanyLink.vue?vue&type=template&id=b867e9c0&scoped=true"
import script from "./CardSingleCompanyLink.vue?vue&type=script&lang=js"
export * from "./CardSingleCompanyLink.vue?vue&type=script&lang=js"
import style0 from "./CardSingleCompanyLink.vue?vue&type=style&index=0&id=b867e9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b867e9c0",
  null
  
)

export default component.exports